<template>
    <div class="">
        <drawer 
            :title="addEditTitle" 
            :dialogShow="addEditShow" 
            @handleChange="handleChangeDrawer"
        >
            <div slot="body">
                <div class="pay-mains">
                    <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
                        <el-form-item ref="rechargeAmount" label="充值金额：" prop="rechargeAmount" :rules="$rules.money">
                            <el-input v-model.trim="form.rechargeAmount" placeholder="请输入充值金额"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                 <div class="drawer-footer">
                    <div class="btns">
                        <el-button type="danger" class="large-btn" @click="onSubmit">保存</el-button>
                    </div>
                </div>
            </div>
        </drawer>
    </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
export default {
    mixins: [minxin],
    components:{drawer},
    data () {
        return {
            addEditTitle: '新增充值额度',
            addEditShow: false,
            form: {
                mobile: ''
            },
            
        }
    },
    created(){
        this.editInit();
    },
    methods: {
        editInit(){
            this.$on('set',function(org){
                Object.assign(this.$data,this.$options.data());
                this.addEditShow = true;
            })
            
        },
        handleChangeDrawer(){
            this.$refs['form'].clearValidate();
            this.addEditShow = false;
            this.$emit('change',false);
        },
        onSubmit(values){
            this.$refs.form.validate((valid,object) => {
                if (valid) {
                    this.$api.post(this.$url.shopRechargeApply.save,this.form)
                    .then( res => {
                        if(res){
                            this.addEditShow = false;
                            this.$emit('change',true);
                        }
                    }).catch(error => {

                    })
                }
            });
        },
    }
}
</script>
<style scoped lang="less">

/deep/ .el-input--small .el-input__inner{
    width: 200px;
    height: 40px;
    line-height: 40px;
}
/deep/ .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label{
    line-height: 40px;
}
.pay-mains{
    padding: 30px;
}
</style>